import L from 'leaflet';

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

function createPopup(data) {
  const div = document.createElement('div');
  div.classList.add("popup");

  div.innerHTML = `<a href="${data.tour.link}" rel="bookmark" title="${data.tour.title}">
    <div class="popup-content">
      <figure class="image">
        <img alt="${data.tour.title}" src="https://image-service.azureedge.net/fetch/and-resize-to/320/from/alsnuff/${data.tour.featured_media.replace('https://alsnuff.de/wp-content/uploads', '')}">
      </figure>
      <span class="is-size-6">${data.tour.title}</span>
    </div>
  </a>`;

  return div;
}

function createCard(data) {
  const div = document.createElement('div');
  div.classList.add("card");
  div.classList.add("related-post");
  const card = `
  <a href="${data.tour.link}" rel="bookmark" title="${data.tour.title}">
    <div class="card-image">
      <figure class="image">
        <img alt="${data.tour.title}" src="https://image-service.azureedge.net/fetch/and-resize-to/900/from/alsnuff/${data.tour.featured_media.replace('https://alsnuff.de/wp-content/uploads', '')}">
      </figure>
    </div>
    <div class="card-content">
      <div class="content">${data.tour.title}</div>
    </div>
  </a>
`;
  div.innerHTML = card;
  return div;
}

function createCards(data) {
  if (Array.isArray(data)) {
    const columns = document.createElement('div');
    columns.classList.add('columns');
    columns.classList.add('is-multiline');

    for (const [index, el] of data.entries()) {
      if (index > 5) {
        break;
      }

      const column = document.createElement('div');
      column.className = 'column';
      const card = createCard(el);
      column.appendChild(card);
      columns.appendChild(column);
    }

    const div = document.getElementById('postsdiv');
    div.innerHTML = '';
    div.appendChild(columns);
  } else {
    const div = document.getElementById('postsdiv');
    div.innerHTML = '';

    const element = createCard(data);
    div.appendChild(element);
  }
}

function htmlToElement(html) {
  var template = document.createElement('template');
  html = html.trim(); // Never return a text node of whitespace as the result
  template.innerHTML = html;
  return template.content.firstChild;
}

function createSideCard(data) {
  if (Array.isArray(data)) {
    return;
  }

  const trackMapDiv = document.getElementById('trackmap');
  const cardDiv = document.createElement('div');
  cardDiv.style = 'position: absolute; top: 2rem; right: 2rem; z-index: 999; max-width: 300px; max-height: ' + trackMapDiv.clientHeight;
  cardDiv.appendChild(htmlToElement('<div class="card related-post hike-summary-data"><a href="https://alsnuff.ch/zwischen-krokussen-und-verbotsschildern-aufs-hochstuckli/" rel="bookmark" title="Hochstuckli: Wanderung via Höch Tändli und Nüsellstock nach Rothenthurm"><div class="card-image"><figure class="image is-4by3 no-process"><img decoding="async" src="https://image-service.azureedge.net/fetch/and-resize-to/900/from/alsnuff/2016/04/DSC_0953-768x514.jpg" alt="Hochstuckli: Wanderung via Höch Tändli und Nüsellstock nach Rothenthurm" class="lazy loaded" loading="lazy" data-ll-status="loaded"></figure></div><div class="card-info-box-container"><div class="card-info-box"><div class="card-info-item"><span class="card-info-item-value">16.9 km</span><span>Distanz</span></div><div class="card-info-item"><span class="card-info-item-value">6.74 h</span><span>Dauer</span></div><div class="card-info-item"><span class="card-info-item-value">923 m</span><span>Aufstieg</span></div><div class="card-info-item difficulty"><span>Schwierigkeit: leicht</span></div></div></div></a><div class="card-content"><a href="https://alsnuff.ch/zwischen-krokussen-und-verbotsschildern-aufs-hochstuckli/" rel="bookmark" title="Hochstuckli: Wanderung via Höch Tändli und Nüsellstock nach Rothenthurm"><div class="title">Hochstuckli: Wanderung via Höch Tändli und Nüsellstock nach Rothenthurm</div></a><div class="content"><a href="https://alsnuff.ch/zwischen-krokussen-und-verbotsschildern-aufs-hochstuckli/" rel="bookmark" title="Hochstuckli: Wanderung via Höch Tändli und Nüsellstock nach Rothenthurm"></a><p><a href="https://alsnuff.ch/zwischen-krokussen-und-verbotsschildern-aufs-hochstuckli/" rel="bookmark" title="Hochstuckli: Wanderung via Höch Tändli und Nüsellstock nach Rothenthurm">Passend zum Sonntag strahlt die Sonne vom Himmel. Genau richtig für eine gemütliche Runde über Hochstuckli und Nüsellstock. Doch unterwegs begegnen wir dem Wächter des Hochstuckli…&nbsp;&nbsp;</a><a class="more-link" href="https://alsnuff.ch/">Weiterlesen →</a></p></div></div></div>'));
  trackMapDiv.appendChild(cardDiv);
}

function showTrack(data, model) {
  if (model.mymap.getZoom() < 11) {
    return;
  }

  var id = -1;

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return;
    }

    id = data[0].tour.id;
  } else {
    id = data.tour.id;
  }

  fetch(`/wp-content/uploads/trackinfo/${id}.json`)
    .then(res => res.json())
    .then(json => {
      model.trackLayerGroup.clearLayers();

      json.features = json.features.filter(x => x.geometry.type == 'MultiLineString');

      var layer = L.geoJson(json, {
        style: {
          color: '#ff2200',
          weight: 4,
          opacity: 0.8
        }
      });
    
      layer.addTo(model.trackLayerGroup);
  });
}

function onOverMarker(e, model) {
  if (model.mandatoryTags) {
    createCards(e.target.data);
  }

  // createSideCard(e.target.data);
  showTrack(e.target.data, model);
}

function inTags(tour, model) {
  return (model.tags.length == 0 || model.tags.some(tag => tour.tags.includes(tag))) &&
    (model.mandatoryTags.length == 0 || model.mandatoryTags.every(tag => tour.tags.includes(+tag)));
}

function inCategories(tour, model) {
  return model.categories.length == 0 || model.categories.some(category => tour.categories.includes(category));
}

function createMarker(markerData) {
  let color = 'grey';
  let iconContent = "<i class='fa fa-hiking awesome'>";

  if (markerData.tour.tags.includes(30) || markerData.tour.tags.includes(31)) {
    color =  '#0274b2';
  }

  if (markerData.tour.tags.includes(32)) {
    color =  '#e3001b';
  }

  if (markerData.tour.tags.includes(34)) {
    color = '#18171c';
  }

  if (markerData.tour.categories.includes(21)) {
    iconContent = "<i class='fa fa-mountain awesome'>";
  }

  if (markerData.tour.categories.includes(22) || markerData.tour.categories.includes(238)) {
    iconContent = "<i class='fa fa-snowflake awesome'>";
  }

  if (markerData.tour.categories.includes(53)) {
    iconContent = "<div class='custom'><img src='https://alsnuff.de/wp-content/themes/alsnuff/images/hochtour.png'></div>";
  }

  if (markerData.tour.categories.includes(50)) {
    iconContent = "<div class='custom'><img src='https://alsnuff.de/wp-content/themes/alsnuff/images/klettern.png'></div>";
  }
  
  return "<div style='background-color:" + color + ";' class='marker-pin'></div>" + iconContent;
}

function setMarkers(model) {
  if (model.isPopupVisible) {
    return;
  }

  model.markerLayerGroup.clearLayers();

  const visibleMarkers = [];

  for (let x = 0; x < 10; x++) {
    const a = [];

    for (let y = 0; y < 10; y++) {
      a.push([]);
    }

    visibleMarkers.push(a);
  }

  model.json.forEach(tour => {
    if (inCategories(tour, model) && inTags(tour, model)) {
      tour.waypoints.forEach(waypoint => {
        if (model.mymap.getBounds().contains([waypoint.latitude, waypoint.longitude])) {
          const x = Math.round((waypoint.longitude - model.mymap.getBounds().getWest()) / (model.mymap.getBounds().getEast() - model.mymap.getBounds().getWest()) * 10 - .5);
          const y = Math.round((waypoint.latitude - model.mymap.getBounds().getSouth()) / (model.mymap.getBounds().getNorth() - model.mymap.getBounds().getSouth()) * 10 - .5);
  
          visibleMarkers[x][y].push({ tour, waypoint });
        }
      });
    }
  });

  const totalTours = [];

  visibleMarkers.forEach(x => {
    x.forEach(y => {
      var color = 'grey';
      var iconContent = "<i class='fa fa-hiking awesome'>";

      if (y.length < 5) {
        y.forEach(markerData => {
          var html = createMarker(markerData);

          if (model.mymap.getZoom() >= 13) {
            html += '<div class="text">' + markerData.waypoint.name + '</div>';
          }

          const icon = L.divIcon({
            className: 'custom-div-icon',
                  html: html,
                  iconSize: [30, 42],
                  iconAnchor: [15, 42]
              });

          const marker = L.marker([markerData.waypoint.latitude, markerData.waypoint.longitude], { icon: icon });
          marker.bindPopup(createPopup(markerData));
          marker.getPopup().on('add', () => model.isPopupVisible = true);
          marker.getPopup().on('remove', () => { model.isPopupVisible = false; setMarkers(model); });
          marker.on('mouseover', e => onOverMarker(e, model));
          marker.data = markerData;
          marker.addTo(model.markerLayerGroup);
        });
      } else if (y.length > 0) {
        const data = [];

        y.forEach(el => {
          if (!data.some(x => x.tour.title == el.tour.title)) {
            data.push(el);
          }
        });

        var html = "";

        if (data.length > 1) {
          iconContent = "<div class='custom'><span>" + data.length + "</span></div>";
          html = "<div style='background-color:" + color + ";' class='marker-pin'></div>" + iconContent;
        } else if (data.length == 1) {
          html = createMarker(data[0]);
        }

        const icon = L.divIcon({
          className: 'custom-div-icon',
                html: html,
                iconSize: [30, 42],
                iconAnchor: [15, 42]
            });
        const marker = L.marker([y[0].waypoint.latitude, y[0].waypoint.longitude], { icon: icon });

        if (data.length == 1) {
          marker.bindPopup(createPopup(data[0]));
          marker.getPopup().on('add', () => model.isPopupVisible = true);
          marker.getPopup().on('remove', () => { model.isPopupVisible = false; setMarkers(model); });
        }

        marker.on('mouseover', e => onOverMarker(e, model));
        marker.data = data;
        marker.addTo(model.markerLayerGroup);
      }

      y.forEach(el => {
        if (!totalTours.some(x => x.tour.title == el.tour.title)) {
          totalTours.push(el);
        }
      });
    });
  });

  if (totalTours.length <= 5) {
    createCards(totalTours);
  }
}

function initializeTags() {
  const tagDiv = document.createElement('div');

  const tags = document.createElement('p');
  tags.classList.add('has-text-centered');
  tags.classList.add('map-tags');

  const leicht = document.createElement('span');
  leicht.className = 'tag';
  leicht.id = 'tag-leicht';
  leicht.textContent = "Leicht";
  leicht.addEventListener('click', () => { toggleTag(30); toggleTag(31); });
  tags.appendChild(leicht);

  const mittel = document.createElement('span');
  mittel.className = 'tag';
  mittel.id = 'tag-mittel';
  mittel.textContent = "Mittel";
  mittel.addEventListener('click', () => toggleTag(32));
  tags.appendChild(mittel);

  const schwer = document.createElement('span');
  schwer.className = 'tag';
  schwer.id = 'tag-schwer';
  schwer.textContent = "Schwer";
  schwer.addEventListener('click', () => toggleTag(34));
  tags.appendChild(schwer);

  tagDiv.appendChild(tags);

  const categories = document.createElement('p');
  categories.classList.add('has-text-centered');
  categories.classList.add('categories');

  const wandern = document.createElement('span');
  wandern.className = 'tag';
  wandern.id = 'category-wandern';
  wandern.innerHTML = "Wandern <i class='fa fa-hiking awesome' style='margin-left: 1em'>";
  wandern.addEventListener('click', () => toggleCategory(173));
  categories.appendChild(wandern);

  const bergwandern = document.createElement('span');
  bergwandern.className = 'tag';
  bergwandern.id = 'category-bergwandern';
  bergwandern.innerHTML = "Bergwandern <i class='fa fa-mountain awesome' style='margin-left: 1em'>";
  bergwandern.addEventListener('click', () => toggleCategory(21));
  categories.appendChild(bergwandern);

  const schneeschuh = document.createElement('span');
  schneeschuh.className = 'tag';
  schneeschuh.id = 'category-schneeschuh';
  schneeschuh.innerHTML = "Schneeschuh <i class='fa fa-snowflake awesome' style='margin-left: 1em'>";
  schneeschuh.addEventListener('click', () => toggleCategory(22));
  categories.appendChild(schneeschuh);

  const winterwandern = document.createElement('span');
  winterwandern.className = 'tag';
  winterwandern.id = 'category-winterwandern';
  winterwandern.innerHTML = "Winterwandern <i class='fa fa-snowflake awesome' style='margin-left: 1em'>";
  winterwandern.addEventListener('click', () => toggleCategory(238));
  categories.appendChild(winterwandern);

  const hochtour = document.createElement('span');
  hochtour.className = 'tag';
  hochtour.id = 'category-hochtour';
  hochtour.innerHTML = "Hochtour <img src='https://alsnuff.de/wp-content/themes/alsnuff/images/hochtour-white.png' style='margin-left: 1em; height: 16px;'>";
  hochtour.addEventListener('click', () => toggleCategory(53));
  categories.appendChild(hochtour);

  const klettersteig = document.createElement('span');
  klettersteig.className = 'tag';
  klettersteig.id = 'category-klettersteig';
  klettersteig.innerHTML = "Klettersteig <img src='https://alsnuff.de/wp-content/themes/alsnuff/images/klettern-white.png' style='margin-left: 1em; height: 16px;'>";
  klettersteig.addEventListener('click', () => toggleCategory(50));
  categories.appendChild(klettersteig);

  tagDiv.appendChild(categories);

  const parent = document.getElementById('trackmapdiv');
  parent.appendChild(tagDiv);
}

function toggleTag(tagId) {
  if (model.tags.includes(tagId)) {
    model.tags.splice(model.tags.indexOf(tagId), 1);
  } else {
    model.tags.push(tagId);
  }

  if (model.tags.length == 0) {
    document.getElementById('tag-leicht').classList.remove('inactive');
    document.getElementById('tag-mittel').classList.remove('inactive');
    document.getElementById('tag-schwer').classList.remove('inactive');
  } else {
    if (!model.tags.includes(30) && !model.tags.includes(31)) {
      document.getElementById('tag-leicht').classList.add('inactive');
    } else {
      document.getElementById('tag-leicht').classList.remove('inactive');
    }

    if (!model.tags.includes(32)) {
      document.getElementById('tag-mittel').classList.add('inactive');
    } else {
      document.getElementById('tag-mittel').classList.remove('inactive');
    }

    if (!model.tags.includes(34)) {
      document.getElementById('tag-schwer').classList.add('inactive');
    } else {
      document.getElementById('tag-schwer').classList.remove('inactive');
    }
  }

  setMarkers(model);
}

function toggleCategory(categoryId) {
  if (model.categories.includes(categoryId)) {
    model.categories.splice(model.categories.indexOf(categoryId), 1);
  } else {
    model.categories.push(categoryId);
  }

  if (model.categories.length == 0) {
    document.getElementById('category-wandern').classList.remove('inactive');
    document.getElementById('category-bergwandern').classList.remove('inactive');
    document.getElementById('category-schneeschuh').classList.remove('inactive');
    document.getElementById('category-winterwandern').classList.remove('inactive');
    document.getElementById('category-hochtour').classList.remove('inactive');
    document.getElementById('category-klettersteig').classList.remove('inactive');
  } else {
    if (!model.categories.includes(173)) {
      document.getElementById('category-wandern').classList.add('inactive');
    } else {
      document.getElementById('category-wandern').classList.remove('inactive');
    }

    if (!model.categories.includes(21)) {
      document.getElementById('category-bergwandern').classList.add('inactive');
    } else {
      document.getElementById('category-bergwandern').classList.remove('inactive');
    }

    if (!model.categories.includes(22)) {
      document.getElementById('category-schneeschuh').classList.add('inactive');
    } else {
      document.getElementById('category-schneeschuh').classList.remove('inactive');
    }

    if (!model.categories.includes(238)) {
      document.getElementById('category-winterwandern').classList.add('inactive');
    } else {
      document.getElementById('category-winterwandern').classList.remove('inactive');
    }

    if (!model.categories.includes(53)) {
      document.getElementById('category-hochtour').classList.add('inactive');
    } else {
      document.getElementById('category-hochtour').classList.remove('inactive');
    }

    if (!model.categories.includes(50)) {
      document.getElementById('category-klettersteig').classList.add('inactive');
    } else {
      document.getElementById('category-klettersteig').classList.remove('inactive');
    }
  }

  setMarkers(model);
}

function loadMap(model) {
  model.mymap = L.map('trackmap', { fullscreenControl: true });
  model.markerLayerGroup = L.layerGroup().addTo(model.mymap);
  model.trackLayerGroup = L.layerGroup().addTo(model.mymap);
  
  fetch('/wp-content/uploads/map/map.json')
    .then(res => res.json())
    .then(data => {
      model.json = data;

      const tagData = document.getElementById('trackmap').getAttribute('data');
      model.mandatoryTags = tagData ? tagData.split(',') : [];

      model.mymap.setView([47, 9], 7);
      model.mymap.on('moveend', () => setMarkers(model));
      model.mymap.on('zoomend', () => setMarkers(model));

      initializeTags();

      const div = document.getElementById('trackmapdiv');
      const postsDiv = document.createElement('div');
      postsDiv.id = 'postsdiv';
      div.appendChild(postsDiv);

      setMarkers(model);
    });

  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 18,
            attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ' +
                '<a href="http://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, ' +
                'Imagery © <a href="http://mapbox.com">Mapbox</a>',
            id: 'mapbox.streets'
        }).addTo(model.mymap);
}

var model = {
  categories: [],
  tags: [],
  mymap: undefined,
  markerLayerGroup: undefined,
  trackLayerGroup: undefined,
  json: undefined,
  isPopupVisible: false
};

var styles = `
#trackmapdiv {
  padding-bottom: 6rem;
}

.marker-pin {
  width: 30px;
  height: 30px;
  border-radius: 50% 50% 50% 0;
  background: #c30b82;
  position: absolute;
  transform: rotate(-45deg);
  left: 50%;
  top: 50%;
  margin: -15px 0 0 -15px;
}

.marker-pin::after {
    content: '';
    width: 24px;
    height: 24px;
    margin: 3px 0 0 3px;
    background: #fff;
    position: absolute;
    border-radius: 50%;
 }

.leaflet-marker-icon .custom {
  position: absolute;
  width: 100%;
  top: 30%;
  display: flex;
  justify-content: center;
}

.leaflet-marker-icon .text {
  position: absolute;
  width: 100%;
  top: 100%;
  display: flex;
  justify-content: center;
  font-weight: bold;
}

.custom-div-icon svg {
   position: absolute;
   width: 22px;
   font-size: 22px;
   left: 0;
   right: 0;
   margin: 10px auto;
   text-align: center;
}

.custom-div-icon svg.awesome {
   margin: 12px auto;
   font-size: 17px;
}

.categories .tag, .map-tags .tag {
  cursor: pointer;
}

#tag-leicht {
  background-color: #0274b2;
}

#tag-mittel {
  background-color: #e3001b;
}

#tag-schwer {
  background-color: #18171c;
}

.inactive {
  background-color: lightgrey !important;
}

.columns {
  margin-top: 0;
}

.card {
  margin-top: 1rem;
  min-width: 20vw;
}

.popup-content {
  display: flex;
  flex-direction: column;
}
`;

var styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

if (typeof LazyLoad == 'undefined') {
  !function(n,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(n="undefined"!=typeof globalThis?globalThis:n||self).LazyLoad=t()}(this,function(){"use strict";function n(){return(n=Object.assign||function(n){for(var t=1;t<arguments.length;t++){var e=arguments[t];for(var i in e)Object.prototype.hasOwnProperty.call(e,i)&&(n[i]=e[i])}return n}).apply(this,arguments)}var t="undefined"!=typeof window,e=t&&!("onscroll"in window)||"undefined"!=typeof navigator&&/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),i=t&&"IntersectionObserver"in window,a=t&&"classList"in document.createElement("p"),r=t&&window.devicePixelRatio>1,o={elements_selector:".lazy",container:e||t?document:null,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",data_bg_hidpi:"bg-hidpi",data_bg_multi:"bg-multi",data_bg_multi_hidpi:"bg-multi-hidpi",data_bg_set:"bg-set",data_poster:"poster",class_applied:"applied",class_loading:"loading",class_loaded:"loaded",class_error:"error",class_entered:"entered",class_exited:"exited",unobserve_completed:!0,unobserve_entered:!1,cancel_on_exit:!0,callback_enter:null,callback_exit:null,callback_applied:null,callback_loading:null,callback_loaded:null,callback_error:null,callback_finish:null,callback_cancel:null,use_native:!1,restore_on_error:!1},c=function t(e){return n({},o,e)},l=function n(t,e){var i,a="LazyLoad::Initialized",r=new t(e);try{i=new CustomEvent(a,{detail:{instance:r}})}catch(o){(i=document.createEvent("CustomEvent")).initCustomEvent(a,!1,!1,{instance:r})}window.dispatchEvent(i)},s="srcset",u="sizes",f="poster",d="llOriginalAttrs",v="data",g="loading",b="loaded",p="applied",h="error",m="native",E="data-",I="ll-status",y=function n(t,e){return t.getAttribute(E+e)},k=function n(t,e,i){var a=E+e;if(null===i){t.removeAttribute(a);return}t.setAttribute(a,i)},A=function n(t){return y(t,I)},L=function n(t,e){return k(t,I,e)},O=function n(t){return L(t,null)},x=function n(t){return null===A(t)},C=function n(t){return A(t)===m},_=[g,b,p,h],N=function n(t,e,i,a){if(t){if(void 0!==a){t(e,i,a);return}if(void 0!==i){t(e,i);return}t(e)}},$=function n(t,e){if(a){t.classList.add(e);return}t.className+=(t.className?" ":"")+e},M=function n(t,e){if(a){t.classList.remove(e);return}t.className=t.className.replace(RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},z=function n(t){t.llTempImage=document.createElement("IMG")},R=function n(t){delete t.llTempImage},T=function n(t){return t.llTempImage},w=function n(t,e){if(e){var i=e._observer;i&&i.unobserve(t)}},G=function n(t){t.disconnect()},D=function n(t,e,i){e.unobserve_entered&&w(t,i)},V=function n(t,e){t&&(t.loadingCount+=e)},F=function n(t){t&&(t.toLoadCount-=1)},H=function n(t,e){t&&(t.toLoadCount=e)},j=function n(t){for(var e,i=[],a=0;e=t.children[a];a+=1)"SOURCE"===e.tagName&&i.push(e);return i},B=function n(t,e){var i=t.parentNode;i&&"PICTURE"===i.tagName&&j(i).forEach(e)},J=function n(t,e){j(t).forEach(e)},P=["src"],S=["src",f],U=["src",s,u],q=[v],K=function n(t){return!!t[d]},Q=function n(t){return t[d]},W=function n(t){return delete t[d]},X=function n(t,e){if(!K(t)){var i={};e.forEach(function(n){i[n]=t.getAttribute(n)}),t[d]=i}},Y=function n(t){!K(t)&&(t[d]={backgroundImage:t.style.backgroundImage})},Z=function n(t,e,i){if(!i){t.removeAttribute(e);return}t.setAttribute(e,i)},nn=function n(t,e){if(K(t)){var i=Q(t);e.forEach(function(n){Z(t,n,i[n])})}},nt=function n(t){if(K(t)){var e=Q(t);t.style.backgroundImage=e.backgroundImage}},ne=function n(t,e,i){$(t,e.class_applied),L(t,p),i&&(e.unobserve_completed&&w(t,e),N(e.callback_applied,t,i))},ni=function n(t,e,i){$(t,e.class_loading),L(t,g),i&&(V(i,1),N(e.callback_loading,t,i))},na=function n(t,e,i){i&&t.setAttribute(e,i)},nr=function n(t,e){na(t,u,y(t,e.data_sizes)),na(t,s,y(t,e.data_srcset)),na(t,"src",y(t,e.data_src))},no=function n(t,e,i){var a=y(t,e.data_bg),o=y(t,e.data_bg_hidpi),c=r&&o?o:a;c&&(t.style.backgroundImage='url("'.concat(c,'")'),T(t).setAttribute("src",c),ni(t,e,i))},nc=function n(t,e,i){var a=y(t,e.data_bg_multi),o=y(t,e.data_bg_multi_hidpi),c=r&&o?o:a;c&&(t.style.backgroundImage=c,ne(t,e,i))},nl=function n(t,e,i){var a=y(t,e.data_bg_set);if(a){var r=a.split("|"),o=r.map(function(n){return"image-set(".concat(n,")")});t.style.backgroundImage=o.join(),""===t.style.backgroundImage&&(o=r.map(function(n){return"-webkit-image-set(".concat(n,")")}),t.style.backgroundImage=o.join()),ne(t,e,i)}},ns={IMG:function n(t,e){B(t,function(n){X(n,U),nr(n,e)}),X(t,U),nr(t,e)},IFRAME:function n(t,e){X(t,P),na(t,"src",y(t,e.data_src))},VIDEO:function n(t,e){J(t,function(n){X(n,P),na(n,"src",y(n,e.data_src))}),X(t,S),na(t,f,y(t,e.data_poster)),na(t,"src",y(t,e.data_src)),t.load()},OBJECT:function n(t,e){X(t,q),na(t,v,y(t,e.data_src))}},nu=function n(t,e){var i=ns[t.tagName];i&&i(t,e)},nf=function n(t,e,i){var a=ns[t.tagName];a&&(a(t,e),ni(t,e,i))},nd=["IMG","IFRAME","VIDEO","OBJECT"],n8=function n(t,e){var i,a;e&&!((i=e).loadingCount>0)&&!((a=e).toLoadCount>0)&&N(t.callback_finish,e)},nv=function n(t,e,i){t.addEventListener(e,i),t.llEvLisnrs[e]=i},ng=function n(t,e,i){t.removeEventListener(e,i)},nb=function n(t){return!!t.llEvLisnrs},np=function n(t,e,i){nb(t)||(t.llEvLisnrs={});var a="VIDEO"===t.tagName?"loadeddata":"load";nv(t,a,e),nv(t,"error",i)},nh=function n(t){if(nb(t)){var e=t.llEvLisnrs;for(var i in e){var a=e[i];ng(t,i,a)}delete t.llEvLisnrs}},nm=function n(t,e,i){R(t),V(i,-1),F(i),M(t,e.class_loading),e.unobserve_completed&&w(t,i)},nE=function n(t,e,i,a){var r=C(e);nm(e,i,a),$(e,i.class_loaded),L(e,b),N(i.callback_loaded,e,a),r||n8(i,a)},nI=function n(t,e,i,a){var r=C(e);nm(e,i,a),$(e,i.class_error),L(e,h),N(i.callback_error,e,a),i.restore_on_error&&nn(e,U),r||n8(i,a)},ny=function n(t,e,i){var a=T(t)||t;if(!nb(a)){var r=function n(r){nE(r,t,e,i),nh(a)},o=function n(r){nI(r,t,e,i),nh(a)};np(a,r,o)}},nk=function n(t,e,i){z(t),ny(t,e,i),Y(t),no(t,e,i),nc(t,e,i),nl(t,e,i)},nA=function n(t,e,i){ny(t,e,i),nf(t,e,i)},nL=function n(t,e,i){var a;(a=t,nd.indexOf(a.tagName)>-1)?nA(t,e,i):nk(t,e,i)},nO=function n(t,e,i){t.setAttribute("loading","lazy"),ny(t,e,i),nu(t,e),L(t,m)},nx=function n(t){t.removeAttribute("src"),t.removeAttribute(s),t.removeAttribute(u)},nC=function n(t){B(t,function(n){nx(n)}),nx(t)},n_=function n(t){B(t,function(n){nn(n,U)}),nn(t,U)},nN={IMG:n_,IFRAME:function n(t){nn(t,P)},VIDEO:function n(t){J(t,function(n){nn(n,P)}),nn(t,S),t.load()},OBJECT:function n(t){nn(t,q)}},n$=function n(t){var e=nN[t.tagName];if(!e){nt(t);return}e(t)},nM=function n(t,e){!(x(t)||C(t))&&(M(t,e.class_entered),M(t,e.class_exited),M(t,e.class_applied),M(t,e.class_loading),M(t,e.class_loaded),M(t,e.class_error))},nz=function n(t,e){n$(t),nM(t,e),O(t),W(t)},nR=function n(t,e,i,a){var r;if(i.cancel_on_exit)A(r=t)===g&&"IMG"===t.tagName&&(nh(t),nC(t),n_(t),M(t,i.class_loading),V(a,-1),O(t),N(i.callback_cancel,t,e,a))},nT=function n(t,e,i,a){var r,o=(r=t,_.indexOf(A(r))>=0);L(t,"entered"),$(t,i.class_entered),M(t,i.class_exited),D(t,i,a),N(i.callback_enter,t,e,a),o||nL(t,i,a)},nw=function n(t,e,i,a){x(t)||($(t,i.class_exited),nR(t,e,i,a),N(i.callback_exit,t,e,a))},nG=["IMG","IFRAME","VIDEO"],nD=function n(t){return t.use_native&&"loading"in HTMLImageElement.prototype},nV=function n(t,e,i){t.forEach(function(n){-1!==nG.indexOf(n.tagName)&&nO(n,e,i)}),H(i,0)},nF=function n(t,e,i){t.forEach(function(n){var t;return(t=n).isIntersecting||t.intersectionRatio>0?nT(n.target,n,e,i):nw(n.target,n,e,i)})},nH=function n(t,e){e.forEach(function(n){t.observe(n)})},nj=function n(t,e){G(t),nH(t,e)},nB=function n(t,e){var a;!(!i||nD(t))&&(e._observer=new IntersectionObserver(function(n){nF(n,t,e)},{root:(a=t).container===document?null:a.container,rootMargin:a.thresholds||a.threshold+"px"}))},nJ=function n(t){return Array.prototype.slice.call(t)},nP=function n(t){return t.container.querySelectorAll(t.elements_selector)},nS=function n(t){var e;return A(e=t)===h},nU=function n(t,e){var i;return i=t||nP(e),nJ(i).filter(x)},n9=function n(t,e){var i;(i=nP(t),nJ(i).filter(nS)).forEach(function(n){M(n,t.class_error),O(n)}),e.update()},nq=function n(e,i){t&&(i._onlineHandler=function(){n9(e,i)},window.addEventListener("online",i._onlineHandler))},n1=function n(e){t&&window.removeEventListener("online",e._onlineHandler)},nK=function n(t,e){var i=c(t);this._settings=i,this.loadingCount=0,nB(i,this),nq(i,this),this.update(e)};return nK.prototype={update:function n(t){var a=this._settings,r=nU(t,a);if(H(this,r.length),e||!i){this.loadAll(r);return}if(nD(a)){nV(r,a,this);return}nj(this._observer,r)},destroy:function n(){this._observer&&this._observer.disconnect(),n1(this),nP(this._settings).forEach(function(n){W(n)}),delete this._observer,delete this._settings,delete this._onlineHandler,delete this.loadingCount,delete this.toLoadCount},loadAll:function n(t){var e=this,i=this._settings;nU(t,i).forEach(function(n){w(n,e),nL(n,i,e)})},restoreAll:function n(){var t=this._settings;nP(t).forEach(function(n){nz(n,t)})}},nK.load=function(n,t){var e=c(t);nL(n,e)},nK.resetStatus=function(n){O(n)},t&&function n(t,e){if(e){if(e.length)for(var i,a=0;i=e[a];a+=1)l(t,i);else l(t,e)}}(nK,window.lazyLoadOptions),nK});
}

new LazyLoad({
  elements_selector: "#trackmap",
  callback_enter: () => loadMap(model)
});